import styled, { css } from 'styled-components';
import { Pagination } from 'antd';
import { COLORS, DEVICES } from '@/theme';

export const StyledPaginationWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const paginationItemStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border-radius: 0;
  border: 0;
  border-left: 1px solid ${COLORS.LIGHT_GRAY};
  border-right: 1px solid ${COLORS.LIGHT_GRAY};
  margin: 0;
`;

const paginationNavButtonsStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  margin-right: 0;
  a {
    color: ${COLORS.BLACK};
  }
`;

export const StyledPagination = styled(Pagination)`
  display: flex;
  max-width: 26rem;
  justify-content: center;
  border: 1px solid ${COLORS.LIGHT_GRAY};
  border-radius: 0.5rem;

  .ant-pagination-item {
    width: 2.4rem;
    height: 2.5rem;
    ${paginationItemStyles};

    @media screen and ${DEVICES.TABLET_S} {
      width: 2.75rem;
    }
  }
  .ant-pagination-prev,
  .ant-pagination-next {
    min-width: 2.4rem;
    height: 2.5rem;
    ${paginationNavButtonsStyles};
    overflow: hidden;

    button {
      &:hover {
        background: ${COLORS.LIGHTEST_GRAY};
        border-radius: 0 !important;
      }
    }

    @media screen and ${DEVICES.TABLET_S} {
      min-width: 4.375rem;
    }
  }
  .ant-pagination-prev {
    &:hover {
      border-radius: 0.5rem 0 0 0.5rem !important;
    }
  }
  .ant-pagination-next {
    &:hover {
      border-radius: 0 0.5rem 0.5rem 0 !important;
    }
  }

  .ant-pagination-disabled {
    background: ${COLORS.LIGHTEST_GRAY};
    a {
      color: ${COLORS.BLACK};
    }
  }
  &&& .ant-pagination-item-active {
    background: ${COLORS.BLACK_PRIMARY};
    border: 1px solid ${COLORS.BLACK_PRIMARY};
    a {
      color: ${COLORS.WHITE};
    }
  }
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    margin-right: 0;
    padding-top: 0.25rem;
  }

  &.ant-pagination-mini {
    width: 18rem;
    height: 2.25rem;
    .ant-pagination-item {
      width: 2.5rem;
      height: 2.25rem;
      ${paginationItemStyles};
    }
    .ant-pagination-prev,
    .ant-pagination-next {
      min-width: 3.5rem;
      height: 2rem;
      ${paginationNavButtonsStyles};
    }
    .ant-pagination-disabled {
      background: ${COLORS.WHITE};
      a {
        color: ${COLORS.BLACK};
      }
    }
    &&& .ant-pagination-item-active {
      width: 2.5rem;
      height: 2.2rem;
      background: ${COLORS.YELLOW_PRIMARY};
      a {
        color: ${COLORS.WHITE};
      }
    }
  }
`;
